import { css } from 'emotion';
import { Direction, Position } from './';
import { animationTransition } from '@joykit/variables';
import { animations } from './animations';
import { TransitionStatus } from 'react-transition-group/Transition';

export namespace styles {
  export const wrapper = css({
    width: '100%'
  });

  export const container = (from: Direction, position: Position, state?: TransitionStatus) => {
    const animationStates = animations.getAnimationStates(from);
    return css(
      {
        position: 'relative',
        display: 'flex',
        transition: animationTransition('opacity', 'transform'),
        opacity: 0,
        transform: `translateY(${from === 'bottom' ? '' : '-'}100%)`,
        '&.slide-enter-active': {
          ...animationStates.entering
        },
        '&.slide-enter-done': {
          ...animationStates.entered
        },
        '&.slide-exit-active': {
          ...animationStates.exited
        }
      },
      position && position === 'absolute'
        ? {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2
          }
        : undefined
    );
  };
}
